import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Corporation, BannerService, PagerService, AlertService, BannerModel, TableHeader, CommonService, ForwarderService} from '../../../services/index'
import { Router } from '@angular/router';
import { Util } from '../../../utils'
declare var $:any;
declare var moment:any;
import _ from 'lodash';



@Component({
  selector: 'banner-list',
  templateUrl: 'banner-list.html' 
})
export class BannerMngListContainer {
  getBannerListSub:Subscription;
  updateCorpStatusSub:Subscription;
  pager: any = {};
  pagedItems:any[];
  searchOption:SearchOption = new SearchOption();

  bannerList:Array<BannerModel> = new Array<BannerModel>();
  tempBannerList = new Array();

  dateFomatter: Function = Util.dateFomatter;
  headerList:Array<TableHeader> = null;
  isOpenBannerDetail = false;
  bannerModal:BannerModel = new BannerModel();

  constructor(private bannerService: BannerService, 
    private pagerService: PagerService, 
    private alertService:AlertService, 
    private router:Router, 
    private commonService:CommonService,
    private forwarderService: ForwarderService) {
      
      this.makeHeader();
      commonService.headerSortedEmit.subscribe(sortedData =>{
        this.tempBannerList = sortedData;
        this.setPage(1);
      });
      commonService.clearHeaderEmit.subscribe(headers =>{
        this.headerList = headers;
      });
  }

  makeHeader(){
    this.headerList = new Array<TableHeader>();
    this.headerList.push(new TableHeader(0, 'bannerId', 'No.', true));
    this.headerList.push(new TableHeader(1, ['delYn', 'bannerStatusCd'], '배너상태', true));
    this.headerList.push(new TableHeader(2, 'isActivity', '게재상태', true));
    this.headerList.push(new TableHeader(3, 'content', '배너 내용', false));
    this.headerList.push(new TableHeader(4, 'cntryNm', '국가', true));
    this.headerList.push(new TableHeader(5, 'contractStatusNm', '계약 상태', true));
    this.headerList.push(new TableHeader(6, 'corporation.corpNm', '회사명', true));
    this.headerList.push(new TableHeader(7, 'insUser', '요청자', false));
    this.headerList.push(new TableHeader(8, 'process', '처리', false));
  }
  
  ngOnInit() {
    this.search(1);
  }

  ngOnDestroy(){
    if(this.getBannerListSub) this.getBannerListSub.unsubscribe();
    if(this.updateCorpStatusSub) this.updateCorpStatusSub.unsubscribe();
  }

  search(page){
    this.getBannerListSub = this.bannerService.getBannerList().subscribe((res:any)=>{
      this.bannerList = res.data;
      this.tempBannerList = this.bannerList;
      if(this.searchOption.conditionText && this.searchOption.conditionText.length > 0){
        this.conditionSearch(page);
      }else{
        this.setPage(page);
      } 
    });
  }
  setPage(page: number) {

    // if(!this.tempBannerList || this.tempBannerList.length < 1) return;

    this.pager = this.pagerService.getPager(this.tempBannerList.length, page);
    // if (page < 1) {
    //   return;
    // } 
    
    this.pagedItems = this.tempBannerList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    
  }

  updateStatus(statusCd, corpId, event){

    event.stopPropagation();
    
    let confirmMsg = "승인";
    if(statusCd == 2){
      confirmMsg = "취소";
    }
    
    let that = this;
    // $.sweetModal.confirm(confirmMsg + " 상태로 변경하시겠습니까?", function() {
    //   let fwdr:Corporation = new Corporation();
    //   fwdr.statusCd = statusCd;
    //   fwdr.corpId = corpId;
    //   that.updateCorpStatusSub = that.fwdrMngService.updateFwdrCorpStatusCd(fwdr).subscribe(
    //     res=>{
    //       if(res.result){
    //         that.alertService.success('상태 변경이 완료되었습니다.');
    //         that.search(that.pager.currentPage);
    //       }
    //     }
    //   );
    // });
  }

  conditionSearch(page){
    if(_.isEmpty(this.bannerList)) return;
    let keyword = (_.upperCase(this.searchOption.conditionText)).replace(/\s/gi, "");
    let statusCd = this.searchOption.conditionType;
    this.tempBannerList = _.map(_.filter(this.bannerList,
      (banner:BannerModel) => {
        if(!keyword) return true;
        // else if (_.upperCase(banner.title).indexOf(keyword) >= 0) return true;
        else if ((_.upperCase(banner.content).replace(/\s/gi, "")).indexOf(keyword) >= 0) return true;
        else if ((_.upperCase(banner.cntryCd).replace(/\s/gi, "")).indexOf(keyword) >= 0) return true;
        else if ((_.upperCase(banner.cntryNm).replace(/\s/gi, "")).indexOf(keyword) >= 0) return true;
        else if (banner.corporation && banner.corporation.corpNm && (_.upperCase(banner.corporation.corpNm).replace(/\s/gi, "")).indexOf(keyword) >= 0) return true;
        else return false;
      }));
    this.tempBannerList = _.map(_.filter(this.tempBannerList,
      (banner:BannerModel) => {
        if(statusCd == 99) return true;
        else if(banner.bannerStatusCd == statusCd && banner.delYn == 0) return true;
        else if(4 == statusCd && banner.delYn == 1) return true;
        else return false;
      }));
    // this.tempBannerList = _.map(_.filter(this.tempBannerList,
    //   (banner:BannerModel) => {
    //     let startDt:number = banner.startDt != null ? Number(banner.startDt) : 19990101;
    //     let endDt:number = banner.endDt != null ? Number(banner.endDt) : 19990101;
    //     if(Number(this.searchOption.startDt) <= startDt && (Number(this.searchOption.endDt) >= endDt || endDt == 21000101)){
    //       return true;
    //     }
    //   }));

    this.setPage(page);
    this.commonService.clearOrderByHeader(this.headerList);
  }

  selectConditionType(event){
    this.searchOption.conditionType = event;
    this.conditionSearch(1);
  }

  handleKeyDown(event){
    if(event.keyCode == 13) this.conditionSearch(1);
  }

  moveCorpInfo(id:number){
    this.router.navigate(['/fwdr/setting', id]);
  }

  openDetail(banner){
    this.bannerModal = banner;
    this.isOpenBannerDetail = !this.isOpenBannerDetail;
  }

  parseToDate(dateStr:string) {
    return moment(dateStr, 'YYYYMMDD').toDate();
  }

  setStartDtm($event) {
    this.searchOption.startDt = moment($event).format('YYYYMMDD');
  }

  setEndDtm($event) {
    this.searchOption.endDt = moment($event).format('YYYYMMDD');
  }

  postRequestPublish(banner:BannerModel, type) {
    if(banner.cntryCd == null) {
      $.sweetModal({
        content: "이 프로모션의 노출구간을 설정해주세요.",
        icon: $.sweetModal.ICON_WARNING,
      });

      return;
    }

    let that = this;
    $.sweetModal.confirm("배너 상태 값을 변경하시겠습니까?", function() {
      let promo = banner;

      let msg = '';

      if(type == 'REQUEST') {
        msg = '요청이 완료되었습니다.';
        promo.bannerStatusCd = 1;
      }
      if(type == 'APPROVAL') {
        msg = '승인이 완료되었습니다.';
        promo.bannerStatusCd = 2;
      }
      if(type == 'CANCEL') {
        msg = '요청이 취소되었습니다.';
        promo.bannerStatusCd = 3;
      }

      that.forwarderService.postBannerStatus(banner.corpId, banner).subscribe(
        resp => {
          if(resp.result) {
            $.sweetModal({
              content: msg,
              icon: $.sweetModal.ICON_SUCCESS,
            });
          } else {
            let body = JSON.parse(resp._body);
            $.sweetModal({
              content: body.errorMsg,
              icon: $.sweetModal.ICON_WARNING,
            });
          }
          that.search(that.pager.currentPage);
          this.commonService.clearOrderByHeader(this.headerList);
        }
      );
    });
  }

  refreshListener(){
    this.search(this.pager.currentPage);
  }

  setBanneStatusNm(banner:BannerModel){
    
    let text = "계약 없음";

    if(banner.contractStatusNm == null){
      return text;
    }

    if(banner.contractStatusNm.indexOf('ING') > -1){
      text = "계약 중";
    }else if(banner.contractStatusNm.indexOf('WILL') > -1){
      text = "계약 예정";
    }else if(banner.contractStatusNm.indexOf('DID') > -1){
      text = "계약 만료";
    }

    text += '(';
    text += Util.dateFomatter(banner.startDt);
    text += '~';

    if(banner.endDt != null && banner.endDt.indexOf('21000101') < 0){
      text += Util.dateFomatter(banner.endDt);
    }else{
      text += '';
    }

    text += ')';

    return text;
  }

}

class SearchOption {
  conditionText:string;
  conditionType:number = 99;
  startDt:string = moment(new Date()).add(-1, 'Y').format('YYYYMMDD');
  endDt:string = moment(new Date()).add(0, 'Y').format('YYYYMMDD');
}



// WEBPACK FOOTER //
// ./src/app/containers/banner/mng/banner-list.ts